module.exports = __webpack_public_path__ + "static/media/WhatWeDo3.24ae574d.svg";